import React, { useMemo, useState } from "react";
import { Icon, Table, Tag, Button, message, Tooltip } from "antd";
import Header from "../../../components/Header";
import MainStyle from "./index.module.scss";
import useRequest from "../../../utils/useRequest";
import {
    getAllStuPaper,
    PaperParams,
    PaperState,
    exportHomework,
    getZipHomeWorkList,
    exportUpdateScore,
    restoreStudentScore
} from "../../../service/homework";
import LoadingWrapper from "../../../components/LoadingWrapper";
import {
    errorMessage,
    getCourseNameByCourseNo,
    toFixedNumber
} from "../../../service/service";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { SorterResult, SortOrder } from "antd/lib/table/interface";
import qs from "qs";
import { BiUndo } from "react-icons/bi";
import useModalHandler from "../../../utils/useModalHandler";
import { DrawerModal } from "../component/Rows/components/DrawerModal";
import { PaginationConfig } from "antd/lib/pagination";
import style from "../../exam/reviewListExam/style.module.scss";
import { ResultMessage } from "../../../components/ResultMessage";
import TaskModal from "../../exam/reviewListExam/components/TaskModal";
import UploadModal from "../../../components/UploadModal";
import UploadFileModal from "./component/UploadFileModal";
import useModalHandlerV3 from "../../../utils/v3/useModalHandler";
import EditScopeModal from "./component/EditScopeModal";
import useRequestFn from "../../../utils/useRequestFn";
import DeleteConfirm from "../../../components/DeleteConfirm";
import { DownloadBtn } from "./component/DownloadBtn";

interface PageHomeworkReviewProps {
    match: { params: PaperParams & { sort: SortOrder | undefined } };
}

export default function PageHomeworkReview({
    match: { params }
}: PageHomeworkReviewProps) {
    const modal = useModalHandler();
    const history = useHistory();

    //记录当前表格筛选条件和排序条件
    const handleSort = qs.parse(String(params.sort));
    const sorterState = handleSort.sorterState;
    const status = handleSort.status === undefined ? [] : handleSort.status;
    const state = handleSort.state === undefined ? [] : handleSort.state;

    const [resetScoreAction, { loading: restLoading }] =
        useRequestFn(restoreStudentScore);

    async function resetScore(studentId: string, paperId?: number) {
        if (!paperId) {
            return;
        }
        try {
            await resetScoreAction(studentId, paperId);
            message.success("重置成功!");
            updateData();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    const [rowKey, setRowKey] = useState(); //获取当前行key值，用于给选中行设置背景色
    const [isLoading, setIsLoading] = useState(true); //默认第一次进入时，页面有加载状态
    const [info, setInfo] = useState({
        studentId: "",
        paperId: "",
        studentNo: "",
        oldScore: -1
    });

    const [paperData, { loading }, updateData] = useRequest(() =>
        getAllStuPaper(params)
    );
    const [courseName] = useRequest(() =>
        getCourseNameByCourseNo(params.courseNo!, params.courseSeq!)
    );

    const data = useMemo(() => {
        if (!paperData) return [];
        return paperData.map(item => ({
            key: item.studentId,
            paperId: item.paperId,
            name: item.name,
            studentId: item.studentId,
            studentNo: item.studentNo,
            className: item.className,
            status: item.homework ? "1" : "0",
            state:
                item.homework && item.homework.state === PaperState.Reviewed
                    ? PaperState.Reviewed
                    : PaperState.NotReviewed,
            finishTime: item.homework ? item.homework.endTime : "",
            score: item.homework ? toFixedNumber(item.homework.score) : 0,
            oldScore: item.homework
                ? toFixedNumber(item.homework.oldScore)
                : -1,
            notes: item?.homework?.notes,
            action: item.homework && (
                <div className={style.flex}>
                    <DeleteConfirm
                        title="确定要重置成绩吗？"
                        onSuccess={() =>
                            resetScore(item?.studentId, item?.homework?.paperId)
                        }>
                        <Button type="link">重置成绩</Button>
                    </DeleteConfirm>

                    <Button
                        type="link"
                        onClick={() =>
                            onClickDetail(
                                item.studentId,
                                item.homework?.paperId + "",
                                item.studentNo,
                                item?.homework?.oldScore || -1
                            )
                        }>
                        <Icon type="right-circle" theme="filled" />
                        详情
                    </Button>
                </div>
            )
        }));
    }, [paperData]);

    function handleExport() {
        exportHomework(params);
    }

    const onHandleSort = (
        pagination: PaginationConfig,
        filters: any,
        sorter: SorterResult<any>
    ) => {
        const status = filters.status;
        const state = filters.state;
        const sorterState = sorter.order;
        const sortAndFilters = {
            sorterState,
            status,
            state
        };
        history.replace(
            `/homework/review/list/${params.courseNo}/${params.courseSeq}/${
                params.weekTime
            }/${params.week}/${params.section}/${params.continunity}/${
                params.weekTimeId
            }/${qs.stringify(sortAndFilters)}`
        );
    };

    //查看详情方法
    const onClickDetail = (
        studentId: string,
        paperId: string,
        studentNo: string,
        oldScore: number
    ) => {
        modal.open();
        setInfo({ studentId, paperId, studentNo, oldScore });
    };

    //更新分数后刷新列表数据
    const refreshData = () => {
        updateData();
        setIsLoading(false);
    };

    const editModal = useModalHandlerV3({
        component: EditScopeModal
    });

    function editSuccess() {
        editModal.close();
        refreshData();
    }
    function editClick(
        studentId: number,
        paperId: number,
        score: number,
        notes: string
    ) {
        editModal.open({
            score,
            notes,
            studentId,
            paperId,
            onSuccess: editSuccess
        });
    }

    const columns = [
        {
            title: "姓名",
            dataIndex: "name",
            render: (text: string) => <a>{text}</a>
        },
        {
            title: "学号",
            dataIndex: "studentNo"
        },
        {
            title: "班级",
            dataIndex: "className"
        },
        {
            title: "提交状态",
            dataIndex: "status",
            width: 120,

            filters: [
                {
                    text: "已提交",
                    value: "1"
                },
                {
                    text: "未提交",
                    value: "0"
                }
            ],
            filterMultiple: true,
            defaultFilteredValue: status as string[],
            onFilter: (value: string, record: any) => record.status === value,
            render: (value: string) =>
                value === "1" ? (
                    <Tag color="#87d068">已提交</Tag>
                ) : (
                    <Tag>未提交</Tag>
                )
        },
        {
            title: "批改状态",
            dataIndex: "state",
            width: 120,
            filters: [
                {
                    text: "已批改",
                    value: PaperState.Reviewed
                },
                {
                    text: "未批改",
                    value: PaperState.NotReviewed
                }
            ],
            filterMultiple: true,
            defaultFilteredValue: state as string[],
            onFilter: (value: string, record: any) => record.state === value,
            render: (value: string) =>
                value === PaperState.Reviewed ? (
                    <Tag color="#87d068">已批改</Tag>
                ) : (
                    <Tag>未批改</Tag>
                )
        },
        {
            title: "完成时间",
            dataIndex: "finishTime",
            sorter: (a: any, b: any) => {
                a = a.finishTime === "" ? 0 : a.finishTime;
                b = b.finishTime === "" ? 0 : b.finishTime;
                return moment(a).diff(b);
            },
            sortOrder: sorterState
                ? (sorterState as "descend" | "ascend")
                : false
        },
        {
            title: "分数",
            dataIndex: "score",
            //上方未定义基础数据接口，不得已使用any
            render: (text: any, item: any) => {
                return (
                    <div className={style.box}>
                        <p>
                            <Tooltip title={item.notes}>{text}</Tooltip>
                            {item.state === PaperState.Reviewed && (
                                <Icon
                                    type="edit"
                                    className={style.edit}
                                    onClick={() => {
                                        editClick(
                                            item.key,
                                            item.paperId,
                                            text,
                                            item.notes
                                        );
                                    }}
                                />
                            )}
                        </p>
                        {!!item?.oldScore && item?.oldScore >= 0 && (
                            <p className={style.tips}>
                                原始分数 {item.oldScore}
                            </p>
                        )}
                    </div>
                );
            }
        },
        {
            title: "操作",
            dataIndex: "action",
            width: 100
        }
    ];

    //设置行属性：获取当前行唯一标识
    const onClickRow = (record: any) => {
        return {
            onClick: () => {
                setRowKey(record.key);
            }
        };
    };

    //表格行的类名：选中项设置背景色
    const setRowClassName = (record: any) => {
        return record.key === rowKey ? MainStyle.clickRowStyle : "";
    };

    const uploadModal = useModalHandler();

    function onClose() {
        uploadModal.close();
    }

    async function onUploadOk(file?: File) {
        if (!file || !paperData || paperData.length < 1) return;
        uploadModal.close();

        try {
            await exportUpdateScore(file, String(paperData[0].paperId!));
            await refreshData();
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    }

    return (
        <div>
            <Header />
            <LoadingWrapper
                loading={isLoading ? loading : false}
                isEmpty={!paperData}>
                {() => (
                    <div className={MainStyle.root}>
                        <div className={MainStyle.title}>
                            <div>
                                {courseName}
                                <Button
                                    className={MainStyle.back}
                                    onClick={() => history.goBack()}>
                                    <BiUndo size={16} /> 返回
                                </Button>
                            </div>

                            <Button
                                size="small"
                                type="primary"
                                onClick={uploadModal.open}>
                                Excel导入更新成绩
                            </Button>
                        </div>

                        <div className={MainStyle.table}>
                            <Table
                                columns={columns}
                                dataSource={data}
                                bordered
                                pagination={false}
                                footer={currentPageData => (
                                    <TableFooter
                                        onExport={handleExport}
                                        data={currentPageData}
                                        courseNo={params.courseNo}
                                        courseSeq={params.courseSeq}
                                        weekTime={params.weekTime}
                                        weekTimeId={params.weekTimeId}
                                    />
                                )}
                                onChange={onHandleSort}
                                rowClassName={setRowClassName}
                                onRow={onClickRow}
                            />

                            {info.paperId &&
                                info.studentId &&
                                info.studentNo && (
                                    <DrawerModal
                                        key={info.studentId}
                                        visible={modal.visible}
                                        onCancel={modal.close}
                                        paperId={info.paperId}
                                        studentId={info.studentId}
                                        studentNo={info.studentNo}
                                        oldScore={info.oldScore}
                                        updateData={refreshData}
                                    />
                                )}
                        </div>
                    </div>
                )}
            </LoadingWrapper>
            {uploadModal.render(
                <UploadModal
                    title="Excel批量导入"
                    onCancel={onClose}
                    onUploadOk={onUploadOk}>
                    <UploadFileModal />
                </UploadModal>
            )}
            {editModal.render()}
        </div>
    );
}

/**
 * 表尾
 * @param data
 * @constructor
 */
export function TableFooter({
    data,
    onExport,
    courseNo,
    courseSeq,
    weekTime,
    weekTimeId
}: {
    data: any[];
    onExport?: () => void;
    courseNo: string;
    courseSeq: string;
    weekTime: string;
    weekTimeId: string;
}) {
    const modal = useModalHandler();
    const [paperList, { loading }] = useRequest(
        () => getZipHomeWorkList(weekTimeId),
        {},
        [weekTimeId, courseNo, courseSeq]
    );

    return (
        <div>
            {onExport && (
                <div style={{ textAlign: "center" }}>
                    <Button type="default" onClick={onExport}>
                        <Icon type="download" /> 导出
                    </Button>

                    <DownloadBtn weekTimeId={weekTimeId} data={data} />
                </div>
            )}

            <TaskModal
                visible={modal.visible}
                onCancel={modal.close}
                dataList={paperList || []}
                loading={loading}
                packageName={`${courseNo}-${courseSeq} 第${weekTime}周作业.zip`}
                show7days
            />
        </div>
    );
}
